import { differenceInSeconds, parseJSON } from 'date-fns';

export function dateSorter(a: string, b: string, mode: 'ASC' | 'DESC') {
  if (mode === 'ASC') {
    return differenceInSeconds(parseJSON(a), parseJSON(b));
  } else if (mode === 'DESC') {
    return differenceInSeconds(parseJSON(b), parseJSON(a));
  }
}
